import { Action, Dispatch } from 'redux';

import { LoadDeliveryOptions } from '../../../weborder/actions/Actions';
import { State } from '../../../weborder/Store';
import { getDeliveryLocationForms } from '../../api/user/user.service';
import { DeliveryLocation } from '../../api/user/user.types';
import { Async, AxiosError, Status } from '../../types/data.types';
import { SetDeliveryLocations } from './user.types';
import { setDeliveryLocations } from './userActions';

export const loadDeliveryLocationForms =
  (deviceId: string, languageCode: string) =>
  (dispatch: Dispatch<Action>, getState: () => State): Promise<void> => {
    const { deliveryOptions } = getState();

    const dispatchSetDeliveryLocations = (
      deliveryLocations: Async<DeliveryLocation[]>,
    ): SetDeliveryLocations =>
      dispatch(setDeliveryLocations(deliveryLocations));

    dispatchSetDeliveryLocations({ status: Status.LOADING });

    return getDeliveryLocationForms({ deviceId, language: languageCode })
      .then((data: DeliveryLocation[]) => {
        dispatchSetDeliveryLocations({
          status: Status.SUCCESS,
          data,
        });

        data.forEach((deliveryLocation) => {
          const deliveryOptionFromRedux =
            deliveryOptions[deliveryLocation.DeliveryLocationId];

          if (deliveryOptionFromRedux?.status !== Status.SUCCESS) {
            // TODO - ORD-59 refactor LoadDeliveryOptions and move to src/core/state/user/userMiddleware.ts
            const thunkDispatch = dispatch as any;
            thunkDispatch(LoadDeliveryOptions(deliveryLocation));
          }
        });
      })
      .catch((error: AxiosError) => {
        dispatchSetDeliveryLocations({
          status: Status.ERROR,
          error,
        });
      });
  };
